import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withProps } from 'recompose'
import { withRouter, Link } from 'react-router'
import { Button, ActionDropdown, H1 } from '@driftt/tide-core-legacy'
import IconSVG from 'svg-inline-react'
import UIDropdown from 'shared-web/src/components/UIDropdown'
import UIDropdownItem from 'shared-web/src/components/UIDropdownItem'
import MarketplaceModalButton from '../MarketplaceModalButton'

import { getAccessToken } from '@driftt/web-auth'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import { CONVERSATION_API } from 'constants/ResourcesConstants'
import ACCESS from 'utils/Access'
import emailIconSrc from '!svg-inline?removeTags=true!images/svg/campaigns/email.svg'
import chatlIconSrc from '!svg-inline?removeTags=true!images/svg/comment-action.svg'
import signatureIconSrc from '!svg-inline?removeTags=true!images/svg/signature-dropdown.svg'


import './style.styl'

const NEW_SALES_SEQUENCE_CLICK = 'new-sales-sequence-click'

const mapStateToProps = state => ({
  createSalesSequencePending: PlaybookSelectors.asyncButtonPending(state, NEW_SALES_SEQUENCE_CLICK),
  enabledPlaybookReportTypes: PlaybookSelectors.getPlaybookReportTypePlansEnabled(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      asyncButtonPress: PlaybookActions.asyncButtonPress,
    },
    dispatch
  ),
})

const Wrapper = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withProps(props => ({
    isPrioritizePage: !!props.saveHandler,
    hasPlaybookCreationChoice: (ACCESS.isAdmin() && props.enabledPlaybookReportTypes.size > 1),
    breadcrumb: !!props.category ? `${props.category}` : '',
    chatPlaybookLink: '/marketplace?tab=chat',
    emailPlaybookLink: '/marketplace?tab=email',
    signaturePlaybookLink: '/marketplace?tab=signature',
    onCreateNewSalesSequence: () => {
      props.actions.asyncButtonPress({
        url: `${CONVERSATION_API}/playbooks?type=OUTBOUND_SEQUENCE&access_token=${getAccessToken()}`,
        method: 'post',
        successMessage: `Success! A new playbook has been created!`,
        errorMessage: `Something went wrong and we couldn’t create your new playbook`,
        clickId: NEW_SALES_SEQUENCE_CLICK,
        successCallback: (res) => {
          setTimeout(() => props.router.push({ pathname: `/playbooks/${res.data.id}/edit` }), 2000)
        },
      })
    },
  })),
)

const CreatePlaybookButtons = ({
  chatPlaybookLink,
  emailPlaybookLink,
  signaturePlaybookLink
}) => (
  <UIDropdown
    title={
        <ActionDropdown className="my-playbooks-link" title="New Playbook" />
    }
    attachment="top right"
    targetAttachment="bottom right"
    offset="0px 0px"
  >
    <UIDropdownItem>
      <a href={chatPlaybookLink}>
        <div className="playbooks-new-item-wrapper playbooks-new-item-wrapper-chat">
          <IconSVG
          className="new-playbook-icon"
          src={chatlIconSrc}
          />
          <div className="playbooks-new-item--content">
            <span className="playbooks-new-item--label">Chat Playbook</span>
            <span className="playbooks-new-item--desc">Messages, Takeovers & Bots</span>
          </div>
        </div>
      </a>
    </UIDropdownItem>
    <UIDropdownItem>
      <a href={emailPlaybookLink}>
        <div className="playbooks-new-item-wrapper playbooks-new-item-wrapper-email">
          <IconSVG
            className="new-playbook-icon"
            src={emailIconSrc}
          />
          <div className="playbooks-new-item--content">
            <span className="playbooks-new-item--label">Email Playbook</span>
            <span className="playbooks-new-item--desc">Emails & Sales Sequences</span>
          </div>
        </div>
      </a>
    </UIDropdownItem>
    <UIDropdownItem>
      <a href={signaturePlaybookLink}>
        <div className="playbooks-new-item-wrapper playbooks-new-item-wrapper-signature">
          <IconSVG
            className="new-playbook-icon"
            src={signatureIconSrc}
          />
          <div className="playbooks-new-item--content">
            <span className="playbooks-new-item--label">Signature Playbook</span>
            <span className="playbooks-new-item--desc">Your Team Signature</span>
          </div>
        </div>
      </a>
    </UIDropdownItem>
  </UIDropdown>
)

const CategoryHeader = ({
  breadcrumb,
  heading,
  saveHandler,
  disableSave,
  loading,
  isPrioritizePage,
  chatPlaybookLink,
  emailPlaybookLink,
  signaturePlaybookLink,
  createSalesSequencePending,
  onCreateNewSalesSequence,
  hasPlaybookCreationChoice,
  hasMarketplaceModal,
  isMarketplaceOpen
}) => (
  <header className="playbooks-category-header">
    <div className="playbooks-category-header--content">
      {breadcrumb &&
        <span className="playbooks-category-header-breadcrumb">
          Playbooks / {breadcrumb}
        </span>
      }
      <H1>{heading || 'Playbooks'}</H1>
    </div>
    <div>
      {isPrioritizePage &&
        <Link to={`/playbooks`}><Button type="tertiary" className="my-playbooks-link-cancel">Cancel</Button></Link>
      }
      {isPrioritizePage &&
        <Button className="my-playbooks-link" type="primary" onClick={saveHandler} disabled={disableSave} loading={loading}>Save & Exit</Button>
      }
      {!isPrioritizePage && hasPlaybookCreationChoice && !hasMarketplaceModal &&
        <CreatePlaybookButtons
          chatPlaybookLink={chatPlaybookLink}
          emailPlaybookLink={emailPlaybookLink}
          signaturePlaybookLink={signaturePlaybookLink}
        />
      }
      {!isPrioritizePage && !hasPlaybookCreationChoice && !hasMarketplaceModal &&
        <div className="playbooks-create-new-buttons">
          <Button href="/marketplace?tab=email" type="secondary">Explore Playbooks</Button>
          <Button onClick={onCreateNewSalesSequence} disabled={createSalesSequencePending} loading={createSalesSequencePending}>New Sales Sequence</Button>
        </div>
      }
      {!isPrioritizePage && hasMarketplaceModal &&
        <MarketplaceModalButton buttonText={ACCESS.isAdmin() ? 'Create new playbook' : 'Create new sequence'} isOpen={isMarketplaceOpen}/>
      }
    </div>
  </header>
)

export default Wrapper(CategoryHeader)



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/Header/index.js